export enum TypeToast {
	SUCCESS = '#5FD08C',
	ERROR = '#FF6F73',
	INFO = '#607EFE',
	WARNING = '#DB942A',
}
